export default {
  methods: {
    formatText(input) {
      if (!input) return "";
      let t = input;
      // Underline __text__ (prima di italic per evitare conflitti con _)
      t = t.replace(/__(.*?)__/g, '<span style="text-decoration:underline">$1</span>');
      // Bold **text**
      t = t.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      // Italic _text_ (singolo underscore rimasto dopo aver consumato i doppi)
      t = t.replace(/_([^_\n]+)_/g, '<em>$1</em>');
      // Strikethrough ~~text~~
      t = t.replace(/~~(.*?)~~/g, '<s>$1</s>');
      // Highlight ==text==
      t = t.replace(/==(.*?)==/g, '<mark style="background:rgba(255,235,59,0.35);padding:0 2px;border-radius:2px">$1</mark>');
      // Inline code `text`
      t = t.replace(/`([^`\n]+)`/g, '<code style="background:rgba(0,0,0,0.07);padding:1px 5px;border-radius:3px;font-family:monospace;font-size:0.9em">$1</code>');
      // Sezione ## titolo (inizio riga)
      t = t.replace(/^## (.+)$/gm, '<div style="font-weight:600;font-size:1.05em;margin:10px 0 4px">$1</div>');
      // Bullet list - item (inizio riga)
      t = t.replace(/^- (.+)$/gm, '<div style="padding-left:14px">• $1</div>');
      // Newline → <br>
      t = t.replace(/\n/g, '<br>');
      return t;
    },
  },
};
